export default __webpack_public_path__ + "static/media/BidsColorIcon.4038be49.svg";